import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Navbar from "../../components/common/Navbar";
import "../../styles/lessonPage/LessonsPage.css";
import config from "../../config/config";
import LessonsCarousel from "../../components/lessonPage/LessonsCarousel"; // Assuming you want to display a carousel for lessons

// Preloader component
const Preloader = () => (
  <div className="preloader m-5">
    <div className="spinner m-5"></div>
  </div>
);

const SubLessonPage = () => {
  const navigate = useNavigate();
  const { lesson_id } = useParams(); // Get lesson_id from the URL
  const location = useLocation();
  const { lesson, userId } = location.state;
  const [subLessons, setSubLessons] = useState([]);
  const [filteredSubLessons, setFilteredSubLessons] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true); // Track loading state

  // Fetch sub-lessons with content and wpm when the component mounts
  useEffect(() => {
    const fetchSubLessons = async () => {
      try {
        const response = await fetch(
          `${config.API_URL}/api/lesson/sub-lessons/${lesson_id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch sub lessons");
        }
        const data = await response.json();

        // Add the lesson title to each subLesson
        const subLessonsWithTitle = data.map((subLesson) => ({
          ...subLesson,
          title: lesson?.title, // Set subLesson.title to the parent lesson.title
        }));

        setSubLessons(subLessonsWithTitle); // Set the fetched data to state
        setFilteredSubLessons(subLessonsWithTitle); // Set the filtered data initially
      } catch (error) {
        console.error("Error fetching sub-lessons:", error);
      }

      setLoading(false); // Set loading to false after data is fetched
    };

    fetchSubLessons();
  }, [lesson_id, lesson?.title]); // Re-run the effect when lesson_id or lesson.title changes

  // Handle search input and filter subLessons
  useEffect(() => {
    if (searchQuery) {
      const filtered = subLessons.filter((subLesson) => {
        const titleMatch = subLesson.title
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
        const wpmMatch = subLesson.wpm
          ? subLesson.wpm.toString().includes(searchQuery)
          : false;
        return titleMatch || wpmMatch;
      });
      setFilteredSubLessons(filtered);
    } else {
      setFilteredSubLessons(subLessons); // Reset filter when search query is cleared
    }
  }, [searchQuery, subLessons]);

  const handleLessonClick = (lesson) => {
    const { groups, title: displayTitle, wpm, individual_lesson_id } = lesson;
    navigate("/test", {
      state: { groups, displayTitle, wpm, individual_lesson_id, userId },
    });
  };

  return (
    <div>
      <Navbar />

      <div className="container-fluid containerDesktop mx-lg-5 mt-5">
        <div className="row">
          <div className="col-lg-6">
            <div className="adContainer">
              <div className="lessonAdContent">
                <div className="lessonAdText">
                  Have you explored the latest updates to our Morse code
                  practice tools yet?
                </div>
                <a href="/practice" className="lessonAdButton mt-lg-4">
                  Begin Training
                </a>
              </div>
              <img
                src="/lessonpage-reading.png"
                alt="advert-reading"
                className="lessonAdImage"
              />
            </div>
          </div>

          <div className="col-lg-6 mt-lg-0 mt-4">
            <div className="adContainer">
              <div className="lessonAdContent">
                <div className="tutorialAdText">
                  Discover our new tutorial series to help you master Morse code
                  faster!
                </div>
                <a href="/tutorial" className="lessonAdButton mt-lg-4">
                  View Tutorials
                </a>
              </div>
              <img
                src="/lessonpage-tutorial.png"
                alt="advert-tutorial"
                className="lessonAdImage"
              />
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="searchContainer mt-3">
          <input
            type="text"
            className="searchBar"
            placeholder="Search Sub-lessons"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <i className="fas fa-search searchIcon"></i>
        </div>
      </div>

      <div className="container-fluid containerDesktop mx-lg-5 mt-2">
        <h1 className="lessonsTitle my-4">
          {lesson?.title.length > 5 ? "COMBINED" : lesson?.title}
        </h1>

        {loading ? (
          <Preloader /> // Show preloader while waiting for the backend to load
        ) : (
          <>
            <LessonsCarousel
              lessons={filteredSubLessons}
              onClick={handleLessonClick}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SubLessonPage;
